<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="12">
        <b-card header="Detalhes">
          <b-col sm="6" lg="4">
              <b-row>
                <b-col sm="6">
                  <Callout variant="info">
                    <small class="text-muted">próximos 10 dias</small><br>
                    <strong class="h4">Fluxo de Caixa</strong>
                  </Callout>
                </b-col>
              </b-row>
              <hr class="mt-0">
          </b-col>
          <b-table  ref="tabelaFluxo" class="mb-0 table-outline" responsive="sm" :small="true" hover :items="tableItemsAreceber" :fields="tableFieldsAreceber" head-variant="light">
            <div slot="historico"  slot-scope="item">
              <template v-if="(item.item.tipo === 1) || (item.item.tipo === 4) ">{{item.item.historico}}</template>
              <template v-else><strong>{{item.item.historico}}</strong></template>
            </div>
            <div slot="dia0" slot-scope="item">
              {{item.item.dia0}}
            </div>
            <div slot="dia1" slot-scope="item">
              {{item.item.dia1}}
            </div>
            <div slot="dia2" slot-scope="item">
              {{item.item.dia2}}
            </div>
            <div slot="dia3" slot-scope="item">
                {{item.item.dia3}}
            </div>
            <div slot="dia4" slot-scope="item">
                {{item.item.dia4}}
            </div>
            <div slot="dia5" slot-scope="item">
                {{item.item.dia5}}
            </div>
            <div slot="dia6" slot-scope="item">
                {{item.item.dia6}}
            </div>
            <div slot="dia7" slot-scope="item">
                {{item.item.dia7}}
            </div>
            <div slot="dia8" slot-scope="item">
                {{item.item.dia8}}
            </div>
            <div slot="dia9" slot-scope="item">
                {{item.item.dia9}}
            </div>
            <div slot="dia10" slot-scope="item">
                {{item.item.dia10}}
            </div>
            <div slot="dia10" slot-scope="item">
                {{item.item.dia9}}
            </div>
          </b-table>
          
        </b-card>
        <form @submit.stop.prevent="post()">
          <b-btn type="button" variant="primary" @click="$router.go('-1')" ><i class="fa fa-arrow-left"></i> Voltar</b-btn>
          <vue-button-spinner  type="submit"  
                                        :isLoading="isLoading" 
                                        :disabled="isLoading"
                                        :status="status">
                    <i class="fa fa-print"></i> Gerar Relatório
          </vue-button-spinner>   
        </form>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { Callout } from '../../components/'
import VueButtonSpinner from '../../components/VueButtonSpinner.vue'

export default {
  name: 'dashboard',
  components: {
    Callout,
    VueButtonSpinner
  },
  data: function () {
    return {
      isLoading: false,
      status: '',
      submmited: false,
      tableItemsAreceber: [
        { isActive: true,
          _rowVariant: 'success',
          historico: 'teste historico',
          dia0: '0,00',
          dia1: '0,00',
          dia2: '0,00',
          dia3: '0,00',
          dia4: '0,00',
          dia5: '0,00',
          dia6: '0,00',
          dia7: '0,00',
          dia8: '0,00',
          dia9: '0,00',
          dia10: '0,00'
        }
      ],
      // tableItemsAreceber: [],
      tableFieldsAreceber: {
        historico: {
          key: 'historico',
          label: 'Histórico',
          class: 'text-left'
        },
        dia0: {
          key: 'dia0',
          label: 'Dia 0',
          class: 'text-right'
        },
        dia1: {
          key: 'dia1',
          label: 'Dia 1',
          class: 'text-right'
        },
        dia2: {
          key: 'dia2',
          label: 'Dia 2',
          class: 'text-right'
        },
        dia3: {
          key: 'dia3',
          label: 'Dia 3',
          class: 'text-right'
        },
        dia4: {
          key: 'dia4',
          label: 'Dia 4',
          class: 'text-right'
        },
        dia5: {
          key: 'dia5',
          label: 'Dia 5',
          class: 'text-right'
        },
        dia6: {
          key: 'dia6',
          label: 'Dia 6',
          class: 'text-right'
        },
        dia7: {
          key: 'dia7',
          label: 'Dia 7',
          class: 'text-right'
        },
        dia8: {
          key: 'dia8',
          label: 'Dia 8',
          class: 'text-right'
        },
        dia9: {
          key: 'dia9',
          label: 'Dia 9',
          class: 'text-right'
        },
        dia10: {
          key: 'dia10',
          label: 'Dia 10',
          class: 'text-right'
        }
      }
    }
  },
  methods: {
    variant (value) {
      let $variant
      if (value <= 25) {
        $variant = 'info'
      } else if (value > 25 && value <= 50) {
        $variant = 'success'
      } else if (value > 50 && value <= 75) {
        $variant = 'warning'
      } else if (value > 75 && value <= 100) {
        $variant = 'danger'
      }
      return $variant
    },
    variantLinha (value) {
      return value === 0 ? 'secondary' : value === 1 ? 'info' : value === 2 ? 'info' : value === 3 ? 'secondary' : value === 4 ? 'danger' : value === 5 ? 'danger' : value === 6 ? 'secondary' : value === 7 ? 'warning' : ''
    },
    flag (value) {
      return 'flag-icon flag-icon-' + value
    },
    numberToReal (numero) {
      if (!numero) {
        return 'R$ 0,00'
      }
      let n = numero.toFixed(2).split('.')
      n[0] = 'R$ ' + n[0].split(/(?=(?:...)*$)/).join('.')
      return n.join(',')
    },
    listarTitulos10Dias () {
      let uri = this.$http.defaults.baseURL.concat('api/protected/fluxocaixa/listarfluxo10dias')
      let promise = this.$http.get(uri)
      let somaAcumulado = {
        isActive: true,
        _rowVariant: 'warning',
        historico: 'ACUMULADO RECEITAS - DESPESAS',
        dia0: 0,
        dia1: 0,
        dia2: 0,
        dia3: 0,
        dia4: 0,
        dia5: 0,
        dia6: 0,
        dia7: 0,
        dia8: 0,
        dia9: 0,
        dia10: 0
      }
      this.tableItemsAreceber = []
      promise.then((data) => {
        if (data) {
          let i
          for (i = 0; i < data.data.length; i++) {
            if (data.data[i].TIPO === 0 || data.data[i].TIPO === 3 || data.data[i].TIPO === 6) {
              this.tableItemsAreceber.push({
                _rowVariant: this.variantLinha(data.data[i].TIPO),
                historico: data.data[i].DESCRICAO,
                tipo: data.data[i].TIPO
              })
            } else {
              this.tableItemsAreceber.push({
                _rowVariant: this.variantLinha(data.data[i].TIPO),
                historico: data.data[i].DESCRICAO,
                tipo: data.data[i].TIPO,
                dia0: this.numberToReal(data.data[i].MES_0),
                dia1: this.numberToReal(data.data[i].MES_1),
                dia2: this.numberToReal(data.data[i].MES_2),
                dia3: this.numberToReal(data.data[i].MES_3),
                dia4: this.numberToReal(data.data[i].MES_4),
                dia5: this.numberToReal(data.data[i].MES_5),
                dia6: this.numberToReal(data.data[i].MES_6),
                dia7: this.numberToReal(data.data[i].MES_7),
                dia8: this.numberToReal(data.data[i].MES_8),
                dia9: this.numberToReal(data.data[i].MES_9),
                dia10: this.numberToReal(data.data[i].MES_10)
              })
            }
          }
          this.tableFieldsAreceber.dia0.label = 'Acumulado'
          if (data.data[0].TIPO === 0) {
            this.tableFieldsAreceber.dia1.label = new Date(data.data[0].NOME_MES1).toISOString().substr(0, 10).split('-').reverse().join('/')
            this.tableFieldsAreceber.dia2.label = new Date(data.data[0].NOME_MES2).toISOString().substr(0, 10).split('-').reverse().join('/')
            this.tableFieldsAreceber.dia3.label = new Date(data.data[0].NOME_MES3).toISOString().substr(0, 10).split('-').reverse().join('/')
            this.tableFieldsAreceber.dia4.label = new Date(data.data[0].NOME_MES4).toISOString().substr(0, 10).split('-').reverse().join('/')
            this.tableFieldsAreceber.dia5.label = new Date(data.data[0].NOME_MES5).toISOString().substr(0, 10).split('-').reverse().join('/')
            this.tableFieldsAreceber.dia6.label = new Date(data.data[0].NOME_MES6).toISOString().substr(0, 10).split('-').reverse().join('/')
            this.tableFieldsAreceber.dia7.label = new Date(data.data[0].NOME_MES7).toISOString().substr(0, 10).split('-').reverse().join('/')
            this.tableFieldsAreceber.dia8.label = new Date(data.data[0].NOME_MES8).toISOString().substr(0, 10).split('-').reverse().join('/')
            this.tableFieldsAreceber.dia9.label = new Date(data.data[0].NOME_MES9).toISOString().substr(0, 10).split('-').reverse().join('/')
            this.tableFieldsAreceber.dia10.label = new Date(data.data[0].NOME_MES10).toISOString().substr(0, 10).split('-').reverse().join('/')
          }
        }
        somaAcumulado.dia0 = (data.data[data.data.length - 1].MES_0)
        somaAcumulado.dia1 = (somaAcumulado.dia0 + data.data[data.data.length - 1].MES_1)
        somaAcumulado.dia2 = (somaAcumulado.dia1 + data.data[data.data.length - 1].MES_2)
        somaAcumulado.dia3 = (somaAcumulado.dia2 + data.data[data.data.length - 1].MES_3)
        somaAcumulado.dia4 = (somaAcumulado.dia3 + data.data[data.data.length - 1].MES_4)
        somaAcumulado.dia5 = (somaAcumulado.dia4 + data.data[data.data.length - 1].MES_5)
        somaAcumulado.dia6 = (somaAcumulado.dia5 + data.data[data.data.length - 1].MES_6)
        somaAcumulado.dia7 = (somaAcumulado.dia6 + data.data[data.data.length - 1].MES_7)
        somaAcumulado.dia8 = (somaAcumulado.dia7 + data.data[data.data.length - 1].MES_8)
        somaAcumulado.dia9 = (somaAcumulado.dia8 + data.data[data.data.length - 1].MES_9)
        somaAcumulado.dia10 = (somaAcumulado.dia9 + data.data[data.data.length - 1].MES_10)

        somaAcumulado.dia0 = this.numberToReal(somaAcumulado.dia0)
        somaAcumulado.dia1 = this.numberToReal(somaAcumulado.dia1)
        somaAcumulado.dia2 = this.numberToReal(somaAcumulado.dia2)
        somaAcumulado.dia3 = this.numberToReal(somaAcumulado.dia3)
        somaAcumulado.dia4 = this.numberToReal(somaAcumulado.dia4)
        somaAcumulado.dia5 = this.numberToReal(somaAcumulado.dia5)
        somaAcumulado.dia6 = this.numberToReal(somaAcumulado.dia6)
        somaAcumulado.dia7 = this.numberToReal(somaAcumulado.dia7)
        somaAcumulado.dia8 = this.numberToReal(somaAcumulado.dia8)
        somaAcumulado.dia9 = this.numberToReal(somaAcumulado.dia9)
        somaAcumulado.dia10 = this.numberToReal(somaAcumulado.dia10)

        this.tableItemsAreceber.push(somaAcumulado)
        return true
      }).then((data) => {
        this.$refs.tabelaFluxo.refresh()
      })
    },
    post () {
      this.isLoading = true
      this.submmited = true
      // let uri = `/api/protected/relatorios/relcompragadoresumidoforcomp?fornecedorId=${this.registro.CLIENTE_ID}&funcionarioId=${this.registro.FUNCIONARIO_ID}&dt1=${this.registro.DT1}&dt2=${this.registro.DT2}&lbFornecedor=${this.parametros.nomecliente}&lbFuncionario=${this.parametros.nomefuncionario}`
      let uri = '/api/protected/relatorios/fluxocaixa/fluxo10dias?&lbempresa=' + window.localStorage.getItem('nomeempresa') +
        '&lbusuario=' + window.localStorage.getItem('nomeusuario')
      this.$http.get(uri, {responseType: 'arraybuffer'})
        .then(response => {
          this.isLoading = false
          this.submmited = false
          this.$toast.success({
            title: 'Sucesso',
            message: 'Relatório Gerado com Sucesso ',
            progressBar: false,
            timeOut: 300,
            showMethod: 'shake',
            position: 'top full width'
          })
          const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/pdf'}))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'fluxodecaixa10dias.pdf')
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        })
        .catch(erro => {
          this.$toast.error({
            title: 'Erro',
            message: 'Ocorreram erros ao gerar o Relatorio ',
            progressBar: false,
            showMethod: 'shake',
            position: 'top full width'
          })
          this.isLoading = false
        })
    }
  },
  created () {
    this.listarTitulos10Dias()
  }
}
</script>



// WEBPACK FOOTER //
// src/views/dashboard/FluxoCaixaDezDias.vue